import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DoctorDataModel } from '../models/doctors/doctor-data.model';
import { TdoClientConfigurationModel } from '../models/clients/tdo-client-configuration.model';
import { ClientLocationDataModel } from '../models/clients/client-location-data.model';
import { DoctorLicenseDataModel } from '../models/doctors/doctor-license-data.model';
import { ContactDataModel } from '../models/person/contact-data.model';
import { DoctorArLocationDataModel } from '../models/doctors/doctor-ar-location-data.model';
import { ArAccountConfigurationModel } from '../models/doctors/ar-account-configuration.model';
import { DoctorContactDataModel } from '../models/doctors/doctor-contact-data.model';
import { DoctorQueryOptionsModel } from '../models/doctors/doctor-query-options.model';
import { DoctorArLocationPaymentProcessorModel } from "../models/doctors/doctor-ar-location-payment-processor.model";
import { CfgARPaymentProcessorModel } from "../models/accountsReceivable/cfg-ar-payment-processor.model";
import { AddressDataModel } from '../models/person/address-data.model';

@Injectable({
  providedIn: 'root'
})
export class DoctorsService {
  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }
  getDoctors(queryModel: DoctorQueryOptionsModel = null): Observable<DoctorDataModel[]> {
    if (!queryModel) {
      queryModel = new DoctorQueryOptionsModel();
    }
    return this.http.post<DoctorDataModel[]>(`/api/doctors`, queryModel)
      .pipe(catchError(this.handleError<any>('getDoctors')));
  }

  // This is to get doctors that have dataDoctorLocations set, not simply a LOCID in dataDoctor
  getDoctorsForDoctorLocation(queryModel: DoctorQueryOptionsModel) {
    return this.http.post<DoctorDataModel[]>('api/doctors/get-doctors-for-doctor-location', queryModel)
      .pipe(catchError(this.handleError<any>('getDoctorsForDoctorLocation')));
  }

  getDoctorsForDoctorLocationV2(queryModel: DoctorQueryOptionsModel) {
    return this.http.post<DoctorDataModel[]>('api/doctors/get-doctors-for-doctor-location-v2', queryModel)
      .pipe(catchError(this.handleError<any>('getDoctorsForDoctorLocationV2')));
  }

  getDoctorById(DoctorId: string): Observable<any> {
    return this.http.get<any>(`/api/doctors/${DoctorId}`)
      .pipe(catchError(this.handleError<any>('GetdataDoctors4CfgDr')));
  }

  getSelectedDoctor(guid: string): Observable<any> {
    return this.http.get<any>(`/api/doctors/${guid}`)
      .pipe(catchError(this.handleError<any>('GetdataDoctors4CfgDr')));
  }

  getSelectedDoctorLic(guid: string): Observable<any> {
    // console.log('guid ', guid);
    return this.http.get<any>(`/api/doctors/license/${guid}`)
      .pipe(catchError(this.handleError<any>('getSelectedDoctorLic')));
  }

  getDoctorContacts(doctorId: string): Observable<ContactDataModel[]> {
    return this.http.get<ContactDataModel[]>(`api/doctors/get-doctor-contacts/${doctorId}`);
  }

  GetDataDoctorById(doctorId: string): Observable<DoctorDataModel> {
    return this.http.get<DoctorDataModel>(`api/doctors/GetDataDoctorById/${doctorId}`);
  }

  getReferringDoctorByCaseId(patientCaseId: string) {
    return this.http.get<DoctorDataModel>(`api/doctors/get-referringDoctorByCaseId/${patientCaseId}`);
  }

  saveDoctorContacts(doctorId: string, contactModel: ContactDataModel[]): Observable<DoctorContactDataModel[]> {
    return this.http.post<DoctorContactDataModel[]>(`api/doctors/save-doctor-contacts/${doctorId}`, contactModel);
  }

  saveDoctorContact(contact: ContactDataModel): Observable<ContactDataModel> {
    return this.http.post<ContactDataModel>('api/doctors/save-doctor-contact', contact);
  }

  saveDoctorPaymentProcessors(doctorId: string, paymentProc: DoctorArLocationPaymentProcessorModel[]): Observable<DoctorArLocationPaymentProcessorModel[]> {
    return this.http.post<DoctorArLocationPaymentProcessorModel[]>(`api/doctors/update-cfg-ar-doctor-payment-processors/${doctorId}`, paymentProc);
  }

  saveDoctorRefLocation(RefDoctorID: string, isSeleted: boolean) {
    return this.http.get<any>(`api/doctors/update-cfg-doctor-ref-location/${RefDoctorID}/${isSeleted}`);
  }


  getContacts(): Observable<any[]> {
    return this.http.get<any>(`/api/doctors/contacts`)
      .pipe(catchError(this.handleError<any>('getContacts')));
  }

  getWorkdays(data: any): Observable<any[]> {
    console.log('getWorkdays-selectedDoctorData ', data);
    return this.http.get<any>(`/api/doctors/workdays/${data}`)
      .pipe(catchError(this.handleError<any>('getWorkdays')));
  }

  callGetenumValidValueItems(Name: string): Observable<any[]> {
    return this.http.get<any>(`api/valid-values/${Name}`)
      .pipe(catchError(this.handleError<any>('callGetenumValidValueItems')));
  }

  callRemoveDoctor(guid: string): Observable<any> {
    console.log('guid doctor ', guid);
    return this.http.post<any>(`/api/doctors/removedr/${guid}`, {})
      .pipe(catchError(this.handleError<any>('callRemoveDoctor')));
  }

  callRemoveLicense(guid: string): Observable<any> {
    console.log('callRemoveLicense guid doctor ', guid);
    return this.http.post<any>(`/api/doctors/removelic/${guid}`, {})
      .pipe(catchError(this.handleError<any>('callRemoveLicense')));
  }

  callPutdataDoctor4CfgDr(isNew: boolean, selectedDoctorData: any): Observable<DoctorDataModel> {
    console.log('callPutdataDoctor4CfgDr', selectedDoctorData);
    if (isNew) {
      return this.http.post<DoctorDataModel>(`/api/doctors/AddNewDoctor`, selectedDoctorData)
        .pipe(catchError(this.handleError<any>('callPutdataDoctor4CfgDr')));
    } else {
      return this.http.put<any>(`/api/doctors/DoctorUpdate`, selectedDoctorData)
        .pipe(catchError(this.handleError<any>('callPutdataDoctor4CfgDr')));
    }
  }

  callInsertDrLicense(licenseDoctorData: any): Observable<DoctorLicenseDataModel> {
    console.log('callInsertDrLicense ', licenseDoctorData);
    return this.http.post<DoctorLicenseDataModel>(`/api/doctors/AddLicense`, licenseDoctorData)
      .pipe(catchError(this.handleError<any>('callInsertDrLicense')));
  }

  callPutLicense(licenseList: any): Observable<void> {
    console.log('callPutLicense', licenseList);
    return this.http.put<void>(`/api/doctors/putLicense`, licenseList)
      .pipe(catchError(this.handleError<any>('callPutLicense')));
  }

  saveLicense(model: DoctorLicenseDataModel): Observable<DoctorLicenseDataModel> {
    return this.http.post<DoctorLicenseDataModel>('api/doctors/save-license', model);
  }

  deleteLicense(model: DoctorLicenseDataModel): Observable<void> {
    return this.http.get<void>(`api/doctors/delete-license/${model.LicenceNumberID}`);
  }

  getClients(): Observable<TdoClientConfigurationModel[]> {
    return this.http.get<TdoClientConfigurationModel>(`api/client-office-location/tdo-clients`)
      .pipe(catchError(this.handleError<any>('getClients')));
  }

  getClientLocations(tdocid: string): Observable<ClientLocationDataModel[]> {
    return this.http.get<ClientLocationDataModel>(`api/ClientOfficeLocationConfiguration/TDOClientsLocations/${tdocid}`)
      .pipe(catchError(this.handleError<any>('getClients')));
  }

  getAllClientLocations(tdocid: string): Observable<ClientLocationDataModel[]> {
    return this.http.get<ClientLocationDataModel>(`api/client-office-location-configuration/all-tdo-clients-locations/${tdocid}`)
      .pipe(catchError(this.handleError<any>('getAllClients')));
  }

  getDoctorArAccounts() {
    return this.http.get<ArAccountConfigurationModel[]>('api/doctors/get-cfg-ar-accounts');
  }

  getDoctorArDoctorPaymentProcessors(doctorARLocId: string) {
    return this.http.get<DoctorArLocationPaymentProcessorModel[]>(`api/doctors/get-cfg-ar-doctor-payment-processors/${doctorARLocId}`);
  }

  getPaymentProcessors(locid: number) {
    return this.http.get<CfgARPaymentProcessorModel[]>(`api/doctors/get-cfg-payment-processors/${locid}`);
  }




  checkIfUserIsDoctor(userId: string) {
    return this.http.get<DoctorDataModel>(`api/doctors/check-if-user-doctor/${userId}`);
  }

  changeDoctorActivityStatus(model: DoctorDataModel) {
    return this.http.post<DoctorDataModel>(`api/doctors/change-doctor-activity-status`, model);
  }

  resetReferrerDoctorCredentials(user: any): Observable<any> {
    console.log("resetReferrerDoctorCredentials");
    console.log(user);
    const payload = {
      Username: user.UserName,
      FirstName: user.FirstName,
      LastName: user.LastName,
      FullName: user.FirstName + " " + user.LastName,
      UserId: user.UserID,
      ContactId: user.ContactId,
      LoginUrl: user.LoginUrl,
      BaseUrl: location.origin
    }
    return this.http.post<any>(`api/doctors/referrer/${user.DoctorId}/resetCredentials`, payload);
  }

  getNewContactAddress(ContactId: string): Observable<AddressDataModel> {
    return this.http.get<AddressDataModel>(`/api/doctors/getNewContactAddress/${ContactId}`);
  }

  getNewCommForContact(ContactId: string): Observable<any> {
    return this.http.get<any>(`/api/doctors/getNewCommForContact/${ContactId}`);
  }

}
